export enum ActiveStateBackground {
  None = 'none',
  Gradient1 = 'gradient1',
  Gradient2 = 'gradient2',
  Gradient3 = 'gradient3',
  Gradient4 = 'gradient4',
  White = 'white',
  Black = 'black',
}

export interface GlowColors {
  leftColor: string;
  rightColor: string;
  poweredByColor?: string;
  logoColor?: string;
}

export const GLOW_COLOR_PALETTES: Record<ActiveStateBackground, GlowColors> = {
  [ActiveStateBackground.Gradient1]: {
    leftColor: '#2a2dbd',
    rightColor: 'rgba(196,114,57,0.95)',
  },
  [ActiveStateBackground.Gradient2]: {
    leftColor: '#3b82f6',
    rightColor: '#1d4ed8',
  },
  [ActiveStateBackground.Gradient3]: {
    leftColor: '#a855f7',
    rightColor: '#10b981',
  },
  [ActiveStateBackground.Gradient4]: {
    leftColor: '#2563eb',
    rightColor: '#10b981',
  },
  [ActiveStateBackground.White]: {
    leftColor: '#FFFFFF',
    rightColor: '#FFFFFF',
    poweredByColor: '#000000',
    logoColor: '#FFFFFF',
  },
  [ActiveStateBackground.Black]: {
    leftColor: '#000000',
    rightColor: '#000000',
  },
  [ActiveStateBackground.None]: {
    leftColor: 'transparent',
    rightColor: 'transparent',
  },
};
